import Btn from './btn'
import Form from './form'
import FormTips from './form_tips'
import Label from './label'
import Table from './table'
import Tag from './tag'
import Tips from './tips'
import Title from './title'

export default {
  ...Form,
  ...Btn,
  ...Title,
  ...Tag,
  ...Table,
  ...Tips,
  ...Label,
  ...FormTips,
}
